import { tap, map, concatMap } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { Pagination } from '@core/models/pagination.model';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { PaymentMode } from '@core/models/payment-mode.model';

@Injectable()
export class PaymentModeDataService extends DefaultDataService<PaymentMode> {

  pagination: Pagination;
  messages$ = new Subject<any[]>();
  selectedReceipt$ = new BehaviorSubject<PaymentMode[]>(null);

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super('PaymentMode', http, httpUrlGenerator, { root: '' });
  }

  getAll(): Observable<PaymentMode[]> {
    return this.http.get<ApiResponse>('/paymentmode').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  add(paymentMode: PaymentMode): Observable<PaymentMode> {
    return this.http.post<ApiResponse>(`/paymentmode`, paymentMode).pipe(
      tap(res => this.messages$.next(res.message)),
      map(res => res.data)
    );
  }

  updatePaymentMode(paymentMode: PaymentMode): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/paymentmode/${paymentMode.id}`, paymentMode).pipe(
      tap(res => this.messages$.next([...res.message]))
    );
  }

  // getById(data: any) {
  //   return this.http.get<ApiResponse>(`/paymentmode/${data.id}`).pipe(
  //     tap(res => this.paginationInit(res)),
  //     map(res => res.data.rows[0])
  //   );
  // }

  getWithQuery(pageParam: string): Observable<PaymentMode[]> {
    return this.http.get<ApiResponse>(`/paymentmode${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    )
  }

  updateStatus(param: any) {
    return this.http.post<ApiResponse>(`/paymentmode/updatestatus`, param).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  getPaymentOptions() {
    return this.http.get<ApiResponse>('/paymentoptiondropdown').pipe(
      map(res => res.data.rows)
    );
  }

  getPaymentProcessors() {
    return this.http.get<ApiResponse>('/paymentprocessordropdown').pipe(
      map(res => res.data.rows)
    );
  }

  getPaymentModes() {
    return this.http.get<ApiResponse>(`/paymentmodedropdown`).pipe(
      map(res => res.data)
    );
  }

  getPaymentAccount(params? : any) {
    const parameter = params ? params : "";
    return this.http.get<ApiResponse>(`/paymentaccountdropdown${parameter}`).pipe(
      map(res => res.data)
    );
  }

  getPaymentAccountList(params: any) {
    return this.http.get<ApiResponse>(`/paymentaccountlist${params}`).pipe(
      map(res => res.data.rows)
    );
  }

  getPaymentAccountById(id: number) {
    return this.http.get<ApiResponse>(`/paymentmode/paymentaccount/${id}`).pipe(
      map(res => res.data)
    );
  }

  getPaymentModeList(params: any) {
    return this.http.get<ApiResponse>(`/eligiblepaymentmode${params}`).pipe(
      map(res => res.data)
    );
  }

  getPaymentProcessorList(params: any) {
    return this.http.get<ApiResponse>(`/eligiblepaymentprocessor${params}`).pipe(
      map(res => res.data)
    );
  }

   getPaymentModePosition(id: number) {
    return this.http.get<ApiResponse>(`/paymentmode/${id}/position`).pipe(
      map(res => res.data)
    );
  }

  updatePaymentModePosition(id: number, data: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/paymentmode/${id}/position`, data).pipe(
      tap(res => this.messages$.next([...res.message]))
    );
  }

  private paginationInit(res: any) {
    if (res) {
      this.pagination = res.data.paginations;
    }
  }
}
